import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import TransList from './TransList';
import "./TransContainer.scss";

@inject('commonStore','transStore')
@observer
class TransContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.transStore.setCommonStoreInfo(this.props.commonStore);
    this.props.transStore.onClear();
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
        {/* <h2>주문관리</h2> */}
        <TransList
          ceType={(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined &&  sessionLoginInfo.ceType !== null) 
            ? sessionLoginInfo.ceType : "" }
          cGbn={(sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) 
            ? sessionLoginInfo.cGbn : "" }
        />
      </Fragment>
    );
  }

}

export default withRouter(TransContainer);
